import axios from "axios";
import React, { useState } from "react";
import styled from "styled-components";
import { toast } from "react-toastify";

import './style.css';
import fundo from "../../../../styles/fundo.svg";

const FormContainer = styled.form`
  width: auto;
  background-color: #f4f4f5;
  display: flex; 
  justify-content: center;
  align-items: flex-start;
  flex-direction: row;
  box-shadow: 0px 0px 2px #ccc;
  padding: 10px;
`;

const DivContainer = styled.form`
  background-color: #f4f4f5;
  display: flex; 
  align-items: flex-start;
  flex-direction: column;

`;


const InputArea = styled.div`
  width: 350px;
  height: auto; 
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 10px 10px;
  margin: 10px;

  
`;




const Input = styled.input`
  width: 90%;
  height: 40px;
  border: 1px solid #ccc; 
  border-radius: 10px;
  padding: 0px 10px;
  background-color: #f4f4f5;
  font-size: 16px;
  color: #3a3f42;

`;



const Label = styled.label`
  color: #3a3f42;
  font-weight: bold;
  font-family: 'Open Sans', sans-serif;
  font-size: 16px;
  margin: 0px 5px;
  padding: 0px 0px 0px 10px; 


`;

const Button = styled.button`
  width: 95%;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  padding: 10px ;
  cursor: pointer;
  border: none;
  background-image: url(${fundo});
  color: #fff;
  font-size: bold;
  font-size: 20px;
  gap: 5px;
  margin-top: 10px;
  border: 1px solid #ccc;
  border-radius: 10px;


`;









const Form = ({ urlApi, fetchColunas, editarNomeLista, modalEditarNomeLista }) => {


  //Token da api
  const token = localStorage.getItem('token');


  //----------------------------------ALTERA O NOME DA LISTA---------------------------------------------------------//
  const [inputValue, setInputValue] = useState('');
  const handleSave = async () => {

    if (inputValue.length > 50) {
      toast.warn("O nome da lista não pode ter mais que 50 caracteres.");
      return;
    }

    try {
      await axios.put(
        `${urlApi}painel-monitoramento/alterar-nome-lista/${editarNomeLista.ID_LISTA}`,
        { descricao_lista: inputValue },
        { headers: { Authorization: `Bearer ${token}` } }
      );

      fetchColunas();
      toast.success("Nome da lista alterado com sucesso.");

      // Fecha o modal depois de um pequeno delay
      setTimeout(() => {
        modalEditarNomeLista();
      }, 1000);
    } catch (error) {
      if (error.response?.data?.error) {
        toast.error(error.response.data.error);
      } else {
        toast.error("Erro ao atualizar o nome da lista.");
      }
    }
  };








  return (
    <>
      <FormContainer>
        <DivContainer  >

          <InputArea>
            <Label>Nome atual da lista:</Label>
            <Input
              value={editarNomeLista.DESCRICAO_LISTA}
              readOnly
              disabled
            />
          </InputArea>
          <InputArea>
            <Label>Digite um novo nome para lista:</Label>
            <Input
              placeholder="Digite aqui..."
              onChange={(e) => setInputValue(e.target.value)}

            />
          </InputArea>

          <InputArea>
            <Button onClick={handleSave} type="button">
              Salvar
            </Button>
          </InputArea>

        </DivContainer>

      </FormContainer>


      <style jsx global>{`
      .swal2-container.custom-swal-container {
        z-index: 9999; 
      }
    `}</style>
    </ >

  );
};

export default Form;


